import Image from 'next/image'
import React from 'react'

const Paternhorizontal = ({ className }: { className?: string }) => {
    return (
        <div className={`relative ${className}`}>
            <div
                className="absolute inset-0 bg-[url('/brand/pattern.webp')] bg-repeat bg-[length:200px] opacity-5"
            />
        </div>

    )
}

export default Paternhorizontal
